import React, { useContext } from 'react'
import { Card, CardHeader, CardContent, Typography, Grid, Divider } from '@material-ui/core';
import { ExpenseTrackerContext } from '../../context/context';

import useStyles from './mainStyles';
import Form from './Form/Form';
import List from './List/List';
import InfoCard from '../InfoCard';

const Main = () => {
  const classes = useStyles();
  const { balance } = useContext(ExpenseTrackerContext);

  return (
    <Card className={classes.root}>
        <CardHeader title="Expense Tracker" subheader="Powered by Speechly, Implemented by Michael Abaniwo and supported by JavaScript Mastery © 2022" />
        <CardContent>
            <Typography align="center" style={{ marginTop: "-15px", fontSize: "1.1rem" }}>Total Balance NGN{balance}</Typography>
            <Typography variant="subtitle1" style={{ lineHeight: "1.5em", marginTop: "20px", fontSize: "1rem" }}>
                <InfoCard />
            </Typography>
            <Divider className={classes.divider} />
            <Form />
        </CardContent>
        <CardContent className={classes.cardContent}>
            <Grid container spacing={2}>
               <Grid item xs={12}>
                   <List />
               </Grid>
            </Grid>
        </CardContent>
    </Card>
  )
}

export default Main